import { Box, Button, Group, TextInput } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { useState } from 'react';
import JurisdictionsSelect from '../JurisdictionsSelect/JurisdictionsSelect';
import ProposalList from './ProposalList';
import { TCommercialProposal } from '@/models/commercial-proposal';

interface Props {
  onSelect: (proposal: TCommercialProposal) => void;
}

export default function SearchableProposalList({ onSelect }: Props) {
  const [term, setTerm] = useState('');
  const [deTerm] = useDebouncedValue(term, 500);
  const [jurisdiction, setJurisdiction] = useState<string | undefined>();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  return (
    <>
      <Group mb="md">
        <TextInput
          size="xs"
          label="Proposal"
          description="Search by proposal name"
          placeholder="Search"
          value={term}
          onChange={(e) => {
            setTerm(e.target.value);
            setPage(1);
          }}
        />
        <JurisdictionsSelect
          value={jurisdiction}
          onChange={(value) => {
            setJurisdiction(value);
            setPage(1);
          }}
        />
      </Group>
      <Box>
        <ProposalList
          onSelect={onSelect}
          term={deTerm}
          jurisdiction={jurisdiction}
          page={page}
          onPaginationInfo={({ totalPages: tp }) => setTotalPages(tp)}
        />
      </Box>
      <Group justify="space-between" align="flex-end">
        {page > 1 ? (
          <Button
            size="xs"
            variant="subtle"
            onClick={() => setPage((p) => p - 1)}
          >
            Previous page
          </Button>
        ) : (
          <Box />
        )}
        {page < totalPages ? (
          <Button
            size="xs"
            variant="subtle"
            onClick={() => setPage((p) => p + 1)}
          >
            Next page
          </Button>
        ) : (
          <Box />
        )}
      </Group>
    </>
  );
}
